import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid} from '@mui/material';

import {SnackBarContext} from '../../../contexts/SnackBarContext/SnackBarContext';
import {ForgotPassword} from '../../../features/user/ForgotPassword/ForgotPassword';
import {useApiWrite} from '../../../hooks/useApiWrite';
import {Post} from '../../../lib/api/POST/Post';
import {PostRoutes} from '../../../lib/api/POST/PostRoutes';

export const ForgotPasswordPage = () => {
  const {dispatchMessage} = useContext(SnackBarContext);
  const {t} = useTranslation();
  const onSuccess = () => {
    dispatchMessage(t('forgotPassword.successMessage'), 'success');
  };

  const onError = () => {
    dispatchMessage(t('forgotPassword.successMessage'), 'success');
  };

  const {makeRequest} = useApiWrite<Post.RequestPasswordReset>({
    method: 'post',
    path: PostRoutes[Post.RequestPasswordReset],
    onSuccess,
    onError,
  });

  const onSubmit = (email: string) => {
    makeRequest({email});
  };

  return (
    <Grid container flexDirection='row' justifyContent='center' alignItems='center'>
      <Grid
        item
        alignItems='center'
        justifyContent='center'
        width='100%'
        maxWidth='544px'
        style={{backgroundColor: 'white', padding: '3rem', borderRadius: '16px'}}
      >
        <ForgotPassword onSubmit={onSubmit} />
      </Grid>
    </Grid>
  );
};
